import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Button from "@mui/material/Button";
import { NavLink, useLocation } from "react-router-dom";
import { v4 } from "uuid";

const mapPathnameToTabId = (pathname: string) =>
  pathname.includes("profile") ? 0 : 1;

export default function NavTabs() {
  const { pathname } = useLocation();
  const [value, setValue] = useState(mapPathnameToTabId(pathname));

  const handleChange = (_: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  useEffect(() => {
    setValue(mapPathnameToTabId(pathname));
  }, [pathname]);

  return (
    <Box
      sx={{
        textAlign: "center",
        borderRight: 1,
        borderColor: "divider",
        minHeight: "100vh",
        minWidth: 200,
      }}
    >
      <h1>CRM SEO</h1>
      <Tabs
        value={value}
        onChange={handleChange}
        aria-label="Vertical tabs example"
        orientation="vertical"
      >
        <Tab label="Profil" component={NavLink} to="/profile" />
        <Tab label="Tous les articles" component={NavLink} to="/" />
      </Tabs>
      <NavLink
        to={`/create-article/${v4()}`}
        style={{ textDecoration: "none" }}
      >
        <Button variant="outlined">Créer un article</Button>
      </NavLink>
    </Box>
  );
}
